import React, {useEffect} from "react";
import {Box, Button} from "theme-ui";
import {Inline} from "@bedrock-layout/inline";
import {useFormContext} from "react-hook-form";
import {useHistory} from "react-router";

function FormControls() {
    const {formState: {isSubmitSuccessful, isSubmitting}, onClear, onSubmit} = useFormContext()
    const history = useHistory();
    const handleCancel = () => history.push('/management')
    const handleSubmit = (e) => onSubmit()

    useEffect(() => {
        return onClear();
    }, [])

    return (
        <Box variant="layout.header.form-controls">
            <Inline gutter='md' align="start" stretch="start">
                <Box py={3} px={5} width="145px"/>
                {isSubmitSuccessful &&
                  <Button variant="primary.text" onClick={handleCancel}>Done</Button>
                }
                {isSubmitSuccessful === false && isSubmitting === false &&
                  <Button variant="primary.text" onClick={handleCancel}>Cancel</Button>
                }
                <Button variant="primary" onClick={handleSubmit}>Publish</Button>
            </Inline>
        </Box>
    );
}

export default FormControls;